export class TagDtoModel {

    label?:string;
    backgroundColor?:string;
    textColor?:string;
    uuid?:string;
}
